<template>
    <div id="requirements-suppliers">
        <!--=====================================-->
        <!--=      About  Quality Area Start    =-->
        <!--=====================================-->
        <section class="section mb--50 mt--100">
            <div class="container">
                <div class="section-heading heading-light-left mb--50">
                    <span class="subtitle primary">Requisitos.</span>
                    <h2 class="font-weight-100">¿Qué <span class="bold">necesito</span> para entrar?</h2>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="p-5 mb-2 bg-white-green">
                            <h5 class="bold">Identificación <br>y trayectoria</h5>
                            <p>
                                Comparte documentación para conocer
                                más a tu empresa. Es necesario al menos
                                un año de operación
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="p-5 mb-2 bg-white-green">
                            <h5 class="bold">Personal <br>Calificado</h5>
                            <p>
                                Queremos conocer a tu equipo
                                y su preparación.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="p-5 mb-2 bg-white-green">
                            <h5 class="bold">Casos <br>de éxito</h5>
                            <p>
                                Platicamos con tus clientes
                                para conocer su experiencia.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <Requirements />
        <Teams /> -->
    </div>
</template>

<script>
export default {
    name: "HowItWorks",
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/icons/cursor-icon.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/icons/sunflower-icon.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/icons/coin-icon.png",
            img4: "https://cdn.redgirasol.com/nuevo_portal/icons/paper-icon.png",
            img5: "https://cdn.redgirasol.com/nuevo_portal/icons/percentage-icon.png",
        }
    }
}

</script>

<style scoped>

.bg-white-green {
    max-height: 18rem;
    background-repeat: round;
}

</style>